import { Button, Form, Icons, Input, Select, Space } from "@pankod/refine-antd";
import { FormInstance } from "antd";
import { SelectProps } from "antd/lib/select";

const MAX_SELLER_NAME_LENGTH = 100;

export type PartnerSellerFormValues = {
  seller_code: string;
  seller_name: string;
  health_insurer_id: string;
};

type PartnerSellerFormProps = {
  form: FormInstance<PartnerSellerFormValues>;
  onFinish: (values: PartnerSellerFormValues) => void;
  healthInsurerSelectProps: SelectProps;
  loading?: boolean;
};

export const PartnerSellerForm: React.FC<PartnerSellerFormProps> = ({
  form,
  onFinish,
  healthInsurerSelectProps,
  loading,
}) => {
  return (
    <Form
      layout="vertical"
      form={form}
      onFinish={onFinish}
      style={{ width: "100%" }}
    >
      <Form.Item
        name="seller_code"
        label="Código do Vendedor"
        rules={[
          { required: true, whitespace: true, message: "Informe o código" },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="seller_name"
        label="Nome do Vendedor"
        rules={[
          { required: true, whitespace: true, message: "Informe o nome" },
          {
            max: MAX_SELLER_NAME_LENGTH,
            message: `Nome deve ter no máximo ${MAX_SELLER_NAME_LENGTH} caracteres`,
          },
        ]}
      >
        <Input maxLength={MAX_SELLER_NAME_LENGTH} />
      </Form.Item>

      <Form.Item
        name="health_insurer_id"
        label="Operadora"
        rules={[{ required: true, message: "Selecione a operadora" }]}
      >
        <Select
          {...healthInsurerSelectProps}
          getPopupContainer={(trigger?: HTMLElement) =>
            trigger?.parentElement || document.body
          }
          dropdownStyle={{ zIndex: 2200 }}
        />
      </Form.Item>

      <Space style={{ width: "100%", justifyContent: "flex-end", marginTop: 20 }}>
        <Button
          type="primary"
          htmlType="submit"
          loading={loading}
          icon={<Icons.SaveOutlined />}
        >
          Salvar
        </Button>
      </Space>
    </Form>
  );
};
